<div class="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-6 text-center focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
  
  <svg class="mx-auto h-6 w-6 text-gray-400"fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
  </svg>
  
  <span class="mt-2 block text-sm font-semibold text-gray-600">Create or select customer to select {{ target }}</span>
</div>